import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, Params, Data } from '@angular/router';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';
import { StoreService } from '../store.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../api.service';
// import { Observable, Subscription } from 'rxjs/Rx';
import './init-login.component.css';

@Component({
  selector: 'app-init-login',
  templateUrl: './init-login.component.html',
  //styleUrls: ['./init-login.component.css'],
  providers: [ApiService],
  encapsulation: ViewEncapsulation.None
})
export class InitLoginComponent implements OnInit {

  token: string;
  qboConnectID: string;
  returnUrl: string;
  syncAllCustomer:boolean=false;
  loadingMessage: string = "Please wait...";
  rahAccounts: SelectItem[] = [];
  qboClass: SelectItem[] = [];
  constructor(private route: ActivatedRoute,
    private router: Router,
    private ss: StoreService,

    private api: ApiService,
    private spinner: NgxSpinnerService) {

  }

  ngOnInit() {
    this.bindCompanies();
  }

  bindCompanies() {
    this.api.get('Rah/GetByAccountID', '').subscribe(
      (res: {}) => this.sucessQboMaster(res),
      error => this.failedQboMaster(<any>error));
  }

  failedQboMaster(res: any) {

  }

  sucessQboMaster(res: any) {
    console.log(res);
    if (res.StatusCode == 0) {
      if (res.Data != null) {
        if (res.Data.length > 0) {
          if (res.Data.length == 1) {
            this.ss.storeAccountID(res.Data[0].AccountID);
            this.returnUrl = 'login';
            if (res.Data[0].RahVerified == true) {
              this.ss.storeQboConnectID(res.Data[0].RahID);
              this.ss.storeCompanyName(res.Data[0].CompanyName);
              this.ss.storeIsClass(res.Data[0].IsClass);
              this.syncAllCustomer = res.Data[0].AsyncWithCustomer;
              this.ss.storeSyncCustomer(res.Data[0].AsyncWithCustomer)


              this.setupCustomerVendorAndAccount();

              // if (res.Data[0].IsRegistrationCompleted == true) {
              //   this.loadingCustomerVendorAndAccount();
              // }
              // else{

              //   this.setupCustomerVendorAndAccount();
              //   this.updateRAHMasterRegistrationCompleted();

              // }

            }
            else {
              this.router.navigate(['/rahsetting']);
            }
          }
          else {
            this.router.navigate(['/switchcompany']);
          }
        }
        else {
          var token = this.ss.fetchToken();
          window.location.href = this.api.qboConnectUrl + token + "&platform=cosmicbills";
        }
      }
      else {
        var token = this.ss.fetchToken();
        window.location.href = this.api.qboConnectUrl + token + "&platform=cosmicbills";
      }
    }

  }

  updateRAHMasterRegistrationCompleted() {

    this.spinner.show();
    this.api.post('Rah/UpdateRAHMasterRegistrationCompleted', "").subscribe(
      (res: {}) => this.succes_updateRah(res),
      error => this.succes_updateRah(<any>error));
  }

  succes_updateRah(resp: any) {
    this.spinner.hide();

  }

  setupCustomerVendorAndAccount() {

    this.syncVendorFromRAH();
  }

  syncVendorFromRAH() {
    this.loadingMessage = "Sync All Vendor...";
    this.spinner.show();
    this.api.post('Rah/SyncAllVendor', "").subscribe(
      (res: {}) => this.succes_syncVendorFromRAH(res),
      error => this.failed_syncVendorFromRAH(<any>error));
  }

  succes_syncVendorFromRAH(resp: any) {
    this.spinner.hide();

    console.log('SyncAllVendor');
    console.log(resp);

    this.getVendor();

    this.syncAccountFromRAH();


  }

  failed_syncVendorFromRAH(resp: any) {
    this.spinner.hide();
    this.getVendor();

    this.syncAccountFromRAH();
  }


  getVendor() {
    this.spinner.show();
    this.loadingMessage = "Get Vendor...";
    this.api.get('Rah/GetAllQboVendor', '').subscribe(
      (res: {}) => this.success_getVendor(res),
      error => this.failed_getVendor(<any>error));
  }

  success_getVendor(resp: any) {
    this.spinner.hide();
    this.ss.storeQboVendors(resp.Data);
  }

  failed_getVendor(resp: any) {
    this.spinner.hide();
  }


  syncAccountFromRAH() {
    this.loadingMessage = "Sync All Accounts...";
    this.spinner.show();
    this.api.post('Rah/SyncAllAccount', "").subscribe(
      (res: {}) => this.succes_syncAccountFromRAH(res),
      error => this.failed_syncAccountsFromRAH(<any>error));
  }

  succes_syncAccountFromRAH(resp: any) {
    this.spinner.hide();
    console.log('SyncAllAccount');
    console.log(resp);
    this.getQboAccount();
    this.syncAllClass();
    // this.syncItemFromRAH();
  }

  failed_syncAccountsFromRAH(resp: any) {
    this.spinner.hide();
    this.getQboAccount();
    //  this.syncItemFromRAH();
    this.syncAllClass();
  }


  getQboAccount() {
    this.spinner.show();
    this.loadingMessage = "Get Accounts...";
    this.api.get('Rah/GetQboAccount', '').subscribe(
      (res: {}) => this.success_getAccounts(res),
      error => this.failed_getAccounts(<any>error));
  }

  success_getAccounts(resp: any) {
    this.spinner.hide();
    if (resp != null) {
      this.ss.storeQboAccount(resp.Data);

    }


  }

  failed_getAccounts(resp: any) {
    this.spinner.hide();


  }

  syncCustomerFromRAH() {
    this.loadingMessage = "Sync All Customer...";
    this.spinner.show();
    this.api.post('Rah/SyncAllCustomer', "").subscribe(
      (res: {}) => this.succes_syncCustomerFromRAH(res),
      error => this.failed_syncCustomerFromRAH(<any>error));
  }

  succes_syncCustomerFromRAH(resp: any) {
    this.spinner.hide();
    this.getCustomer();

  }

  failed_syncCustomerFromRAH(resp: any) {
    this.spinner.hide();
    this.getCustomer();



  }



  getCustomer() {
    this.spinner.show();
    this.loadingMessage = "Get Customer...";
    this.api.get('Rah/GetAllQboCustomer', '').subscribe(
      (res: {}) => this.success_getCustomer(res),
      error => this.failed_getCustomer(<any>error));
  }

  success_getCustomer(resp: any) {
    this.spinner.hide();
    this.ss.storeQboCustomers(resp.Data);
  }

  failed_getCustomer(resp: any) {
    this.spinner.hide();
  }



  syncAllClass() {
    this.loadingMessage = "Sync All Class...";
    this.spinner.show();
    this.api.post('Rah/SyncAllClass', "").subscribe(
      (res: {}) => this.succes_syncClassFromRAH(res),
      error => this.failed_syncClassFromRAH(<any>error));
  }

  succes_syncClassFromRAH(resp: any) {
    this.spinner.hide();
    this.getQboClass();
    this.syncItemFromRAH();
  }

  failed_syncClassFromRAH(resp: any) {
    this.spinner.hide();
    this.syncItemFromRAH();
  }


  syncItemFromRAH() {
    this.loadingMessage = "Sync All Items...";
    this.spinner.show();
    this.api.post('Rah/SyncAllItem', "").subscribe(
      (res: {}) => this.succes_syncItemsFromRAH(res),
      error => this.failed_syncItemsFromRAH(<any>error));
  }

  succes_syncItemsFromRAH(resp: any) {
    this.spinner.hide();
    this.getQboItem();
    this.RahSyncTerms();

  }

  failed_syncItemsFromRAH(resp: any) {
    this.spinner.hide();
    this.getQboItem();
    this.RahSyncTerms();

  }

  RahSyncTerms() {
    this.loadingMessage = "Sync All Terms...";
    this.spinner.show();
    this.api.post('Rah/SyncAllTerms', "").subscribe(
      (res: {}) => this.succes_syncTermsFromRAH(res),
      error => this.failed_syncTermsFromRAH(<any>error));
  }

  succes_syncTermsFromRAH(resp: any) {
    this.spinner.hide();
    this.syncAllSalesTax();
  }

  failed_syncTermsFromRAH(resp: any) {
    this.spinner.hide();
    this.syncAllSalesTax();

  }

  syncAllSalesTax() {
    this.loadingMessage = "Sync All Tax...";
    this.spinner.show();
    this.api.post('Rah/SyncAllSalesTax', "").subscribe(
      (res: {}) => this.succes_syncTaxFromRAH(res),
      error => this.failed_syncTaxFromRAH(<any>error));
  }

  succes_syncTaxFromRAH(resp: any) {

    this.spinner.hide();


    setTimeout(() => {
      this.syncCustomerFromRAH();
      this.getQboSalesTax();
    },
      10000);


  }
  failed_syncTaxFromRAH(resp: any) {
    this.spinner.hide();
    setTimeout(() => {
      this. syncVendorFromRAH1();
      this.syncCustomerFromRAH();
      this.getQboSalesTax();

    },
      10000);


  }

  syncVendorFromRAH1() {
 
    this.spinner.show();
    this.api.post('Rah/SyncAllVendor', "").subscribe(
      (res: {}) => this.succes_syncVendorFromRAH1(res),
      error => this.failed_syncVendorFromRAH1(<any>error));
  }

  succes_syncVendorFromRAH1(resp: any) {
    this.spinner.hide();

    console.log('SyncAllVendor');
    console.log(resp);

    this.getVendor();




  }

  failed_syncVendorFromRAH1(resp: any) {
    this.spinner.hide();
    this.getVendor();

  }

  getQboClass() {
    this.spinner.show();
    this.loadingMessage = "Get Accounts...";
    this.api.get('Rah/GetQboClass', '').subscribe(
      (res: {}) => this.success_getClasses(res),
      error => this.failed_getClasses(<any>error));
  }

  success_getClasses(resp: any) {
    this.spinner.hide();
    if (resp != null) {
      this.ss.storeQboClass(resp.Data);
    }
  }

  failed_getClasses(resp: any) {
    this.spinner.hide();
  }










  getQboItem() {
    this.spinner.show();
    this.loadingMessage = "Get Items...";
    this.api.get('Rah/GetQboItem', '').subscribe(
      (res: {}) => this.success_getItems(res),
      error => this.failed_getItems(<any>error));
  }

  success_getItems(resp: any) {
    this.spinner.hide();
    if (resp != null) {
      this.ss.storeQboItem(resp.Data);
    }

  }

  failed_getItems(resp: any) {
    this.spinner.hide();

  }












  //storeQboSalesTax

  getQboSalesTax() {
    this.spinner.show();
    this.loadingMessage = "Get Tax...";
    this.api.get('Rah/GetQboSalesTax', '').subscribe(
      (res: {}) => this.success_getTax(res),
      error => this.failed_getTax(<any>error));
  }


  success_getTax(resp: any) {
    this.spinner.hide();
    this.ss.storeQboSalesTax(resp.Data);
    this.router.navigate(['/mapaccount']);
  }

  failed_getTax(resp: any) {
    this.spinner.hide();
    this.router.navigate(['/mapaccount']);
  }
}
